import { SvgIcon } from '@progress/kendo-react-common';
import clsx from 'clsx';
import { FlightDetailsPinnedModel } from '../../../../flights/interop/flightDto';
import { DateTimeFormatter, UnitFormatter } from '../../../../formatters';
import { AirplaneIcon } from '../../../../icons/icons';

export default function FlightHeader({
    id,
    flight,
    airportSummaryLinks,
    onAirportClicked
}: {
    id?: string;
    flight: FlightDetailsPinnedModel;
    airportSummaryLinks: boolean;
    onAirportClicked?: (id: string) => void;
}) {
    return (
        <div className="d-flex px-2 py-2 gap-2 align-items-center" id={id}>
            <div className="d-flex flex-column align-items-center">
                <div
                    onClick={() => flight.origin && onAirportClicked?.(flight.origin)}
                    className={airportSummaryLinks ? 'text-decoration-underline cursor-pointer' : undefined}>
                    {flight.origin ?? 'N/A'}
                </div>
                <div>{DateTimeFormatter.formatTime(flight.departureTime, 'hm') || '--:--'}</div>
            </div>
            <div className="px-2 flex-grow-1 d-flex flex-column align-items-center justify-content-center">
                <div>{flight.acid}</div>
                <div style={{ height: 20 }} className="w-100 d-flex flex-column justify-content-center">
                    <div className="position-relative" style={{ height: 2, background: 'var(--color-neutral-700)' }}>
                        {flight.progressPercentage !== null && (
                            <>
                                <div
                                    style={{
                                        height: 2,
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        background: 'var(--info-blue)',
                                        right: (1 - flight.progressPercentage) * 100 + '%'
                                    }}></div>
                                <SvgIcon
                                    icon={AirplaneIcon}
                                    style={{
                                        width: 18,
                                        height: 18,
                                        position: 'absolute',
                                        right: (1 - flight.progressPercentage) * 100 + '%',
                                        top: 0,
                                        transform: 'translate(50%, -46%)'
                                    }}
                                />
                            </>
                        )}
                    </div>
                </div>
                <div className="secondary-text">
                    {UnitFormatter.formatAltitude(flight.altitude)} {UnitFormatter.formatSpeed(flight.speed)}
                </div>
            </div>
            <div className="d-flex flex-column align-items-center">
                <div
                    onClick={() => flight.destination && onAirportClicked?.(flight.destination)}
                    className={clsx('flight-header-destination', airportSummaryLinks && 'text-decoration-underline cursor-pointer')}>
                    {flight.destination ?? 'N/A'}
                </div>
                <div>{DateTimeFormatter.formatTime(flight.arrivalTime, 'hm') || '--:--'}</div>
            </div>
        </div>
    );
}
